<template>
  <div>
    <h3>Paint brand selection</h3>
    <p class="pad-h">Enable / disable color families. Disabled color families will not appear in the list of
                     matches and purchase recommendations below.</p>
    <div class="form color-families">
      <label v-for="cf in colorFamilies" :key="cf.family" :class="{ checked: cf.isEnabled }">
        <input type="checkbox" :checked="cf.isEnabled" @click="toggleFamily(cf)">
        <img :src="cf.logo" alt="">
        <span>{{ cf.shortName }}</span>
      </label>
    </div>
    <h3>Import / export</h3>
    <form>
      <p>This tool stores the list of paints you own and the paint brand settings in the browser's local
         storage.<br/>
         Use the buttons below to transfer these settings between computers / browsers.<br/>
         Note that you no longer need to go through this process if you are logged in.</p>
      <div class="actions" style="justify-content: flex-start; margin: 0;">
        <p>
          <button @click="exportCollection">Export my collection</button>
          <label for="import_file" class="file-upload-label">
            <input id="import_file"
                   type="file"
                   class="btn"
                   @change="importCollection">Import a collection
          </label>
        </p>
      </div>
    </form>
  </div>
</template>

<script>
  import MD5 from 'crypto-js/md5';
  import keyValueStore from '@/keyValueStore';
  import Recipe from '@/models/Recipe';

  export default {
    props: {
      colorFamilies: Array,
    },
    components: {},
    computed: {
      enabledFamilies() {
        return this.colorFamilies.filter(x => x.isEnabled).map(x => x.family);
      },
    },
    methods: {
      toggleFamily(f) {
        f.isEnabled = !f.isEnabled;
        window.localStorage.setItem('enabled-families', this.enabledFamilies);

        if (this.$auth.isAuthenticated) {
          const { email } = this.$auth.user;
          const md5 = MD5(email).toString();
          keyValueStore.set('enabled-families', md5, this.enabledFamilies);
        }
      },
      exportCollection() {
        if (window.localStorage.getItem('owned-colors') != null
            && window.localStorage.getItem('enabled-families') != null) {
          const ownedColors = window.localStorage.getItem('owned-colors');
          const enabledFamilies = window.localStorage.getItem('enabled-families');
          const recipes = window.localStorage.getItem('recipes') || [];
          debugger;
          this.download(JSON.stringify({
            ownedColors,
            enabledFamilies,
            recipes,
          }), 'color-matcher.json', 'application/json');
        }
      },
      async importCollection(e) {
        const reader = new window.FileReader();
        reader.onload = (event) => {
          const data = JSON.parse(event.target.result);
          window.localStorage.setItem('owned-colors', data.ownedColors);
          window.localStorage.setItem('enabled-families', data.enabledFamilies);
          if (this.$auth.isAuthenticated) {
            const { email } = this.$auth.user;
            const md5 = MD5(email).toString();
            keyValueStore.set('owned-colors', md5, data.ownedColors);
            keyValueStore.set('enabled-families', md5, data.enabledFamilies);
          }
          if (data.recipes != null) {
            const recipeJSON = JSON.stringify(JSON.parse(data.recipes).map(x => Recipe.fromApi(x).toApi()));
            window.localStorage.setItem('recipes', recipeJSON);
            if (this.$auth.isAuthenticated) {
              const { email } = this.$auth.user;
              const md5 = MD5(email).toString();
              keyValueStore.set('recipes', md5, recipeJSON);
            }
          }

          // TODO reload owned colors...
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        };
        reader.readAsText(e.target.files[0]);
      },
      download(data, filename, type) {
        const file = new Blob([data], { type: type });
        if (window.navigator.msSaveOrOpenBlob) // IE10+
        {
          window.navigator.msSaveOrOpenBlob(file, filename);
        } else { // Others
          const a = document.createElement('a');
          const url = URL.createObjectURL(file);
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          setTimeout(function () {
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
          }, 0);
        }
      },
    },
    mounted() {
    },
  };
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import '../vars.scss';

.color-families {
  display: flex;
  flex-wrap: wrap;
  /*justify-content: center;*/
}

.color-families label {
  border: solid 1px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 8px 8px 8px 0;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  margin-bottom: 6px;
  width: 140px;
}

.color-families label:hover {
  background: rgba(50, 205, 50, 0.15);
}

.color-families label input {
  opacity: 0;
  width: 0;
}

.color-families label.checked {
  font-weight: 600;
  background: rgba(50, 205, 50, 0.27);
  border-color: #38b15a;
}

.color-families img {
  height: 28px;
  margin-right: 8px;
  margin-left: 8px;
}

.color-families label.checked img {
}

</style>
